import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class MembersignserviceService {

  constructor(private http: HttpClient) { }

  GetSignsByMemberIdAsync(roleid, id) {
    return this.http.get<any>(environment.apiUrl + 'Sign/GetMemberSignsByMemberIdAsync/' + roleid + '/' + id);
  }

  GetMaterials() {
    return this.http.get<any>('http://localhost:8080/materials');
  }
}
